module.exports = __webpack_public_path__ + "static/media/Btn_Close.be4d7bc1.png";